import React, {FC} from 'react';
import {useDispatch} from 'react-redux';

import {
    pickDataFromQueryByAdditionalFields,
} from 'components/table/action/table-action.utils';
import {selectMetadata} from 'entities/metadata';
import {
    actionsRequestButton,
} from 'modules/data/data-actions';
import {EEntityType} from 'shared/constants/entities';
import {useRequiredQueryParams} from 'shared/hooks/use-required-query-params';
import {useUserRoleFunctions} from 'shared/hooks/use-user-role-functions';
import {useQueryParams} from 'shared/utils/query-params';
import {useAppSelector} from 'store/config/hooks';

import {ActionButton} from '../action-button';
import {ITableActionProps} from '../table-action-types';

export const ButtonsActionSendRequest: FC<ITableActionProps> = ({
    wrapper,
    meta,
    entityName,
    ...props
}: ITableActionProps) => {
    const dispatch = useDispatch();

    const {
        actionCode,
        requestType,
        referenceUrl,
        additionalInfoKeys,
        actionIcon,
        actionTitle,
        requiredQueryParams,
    } = meta;

    const {urlConfig} = useAppSelector(selectMetadata(entityName, EEntityType.TABLE)) || {};
    const {getQueryParam} = useQueryParams();

    const {hasUserRoleFunction} = useUserRoleFunctions({sections: [`app.${entityName}`]});
    const shouldDisplayAction = hasUserRoleFunction(actionCode);

    const {isDisabled} = useRequiredQueryParams({requiredQueryParams});

    const handleClick = () => {
        const additionalData = pickDataFromQueryByAdditionalFields({additionalInfoKeys, getQueryParam});

        dispatch(actionsRequestButton(
            referenceUrl,
            requestType,
            additionalData,
            undefined,
            meta?.shouldIgnoreUrlConfig ? undefined : urlConfig,
        ));
    };

    const Component = wrapper || ActionButton;

    return shouldDisplayAction ? (
        <Component
            {...props}
            onClick={handleClick}
            actionIcon={actionIcon}
            disabled={isDisabled}
        >
            {actionTitle}
        </Component>
    ) : null;
};
